export const MAX_NAME_FIELD_CHARS = 200;

export const MAX_CATEGORY_ENTITY_NAME_CHARS = 200;

export const MAX_SHORTCODE_CHARS = 200;

export const MAX_CATEGORY_ENTITY_SHORTCODE_CHARS = MAX_SHORTCODE_CHARS;

export const MAX_PROCESS_NAME_CHARS = 200;

export const MAX_PROCESS_STEP_NAME_CHARS = 200;

export const MAX_PROCESS_TASK_NAME_CHARS = 800;

export const MAX_ROLE_SHORTCODE_CHARS = MAX_SHORTCODE_CHARS;

export const MAX_FEEDBACK_SUBJECT_CHARS = 250;

export const MAX_TAG_NAME_CHARS = 255;
